import React from 'react';

const CreateUpdateMedicineForm = () => {
    return (
        <div>
            CreateUpdateMedicineForm
        </div>
    )
};

export default CreateUpdateMedicineForm;